import React, { useEffect, useState } from 'react';
import {
  Modal,
  Button,
  Table,
  Spinner,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import { FaRegCopy, FaRegStickyNote } from 'react-icons/fa';
import { toast } from 'react-toastify';
import selectEcoById from '../../../services/ecodoppler';
import api from '../../../services/api';

export default function ModalEco({ show, onHide, codPac, onSelect, onCopy }) {
  const [laudos, setLaudos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hoveredRow, setHoveredRow] = useState(null);

  useEffect(() => {
    if (show && codPac) {
      setLoading(true);
      api
        .get(`/ecocardiograma?codPac=${codPac}`)
        .then(res => setLaudos(res.data))
        .catch(() => toast.error('Erro ao buscar laudos anteriores.'))
        .finally(() => setLoading(false));
    }
  }, [show, codPac]);

  const handleSelect = laudo => {
    onSelect(laudo.OBSERVACOES);
    onHide();
  };

  const handleCopy = async laudo => {
    const ecoSelected = await selectEcoById(laudo.CODECO);
    onCopy(ecoSelected);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Selecionar Laudo Anterior</Modal.Title>
        <br></br>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" />
          </div>
        ) : laudos.length === 0 ? (
          <p className="text-center text-muted">Nenhum laudo encontrado.</p>
        ) : (
          <Table
            size="sm"
            style={{ marginTop: 10, background: '#f8f9fa' }}
            striped
            hover
            bordered
            responsive
          >
            <thead>
              <tr>
                <th style={{ width: '110px', textAlign: 'center' }}>Data</th>
                <th style={{ width: '120px', textAlign: 'center' }}>Tipo</th>
                <th style={{ width: '120px', textAlign: 'center' }}>Código</th>
                <th style={{ width: '180px', textAlign: 'center' }}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {laudos.map((laudo, idx) => (
                <tr
                  key={laudo.CODECO}
                  style={hoveredRow === idx ? { background: '#e9ecef' } : {}}
                  onMouseEnter={() => setHoveredRow(idx)}
                  onMouseLeave={() => setHoveredRow(null)}
                >
                  <td style={{ textAlign: 'center' }}>{laudo.dataEcoFmt}</td>
                  <td style={{ textAlign: 'center' }}>{laudo.TIPOLAUDO}</td>
                  <td style={{ textAlign: 'center' }}>{laudo.CODECO}</td>
                  <td style={{ textAlign: 'center' }}>
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-obs-${laudo.CODECO}`}>
                          Copiar apenas observação
                        </Tooltip>
                      }
                    >
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        style={{ marginRight: 8 }}
                        onClick={() => handleSelect(laudo)}
                      >
                        <FaRegStickyNote style={{ marginRight: 4 }} />
                        Observação
                      </Button>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-laudo-${laudo.CODECO}`}>
                          Copiar todos os dados do laudo
                        </Tooltip>
                      }
                    >
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => handleCopy(laudo)}
                      >
                        <FaRegCopy style={{ marginRight: 4 }} />
                        Laudo
                      </Button>
                    </OverlayTrigger>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
